import React, { useState, useEffect } from "react";
import axios from "axios";
import { shallow } from "zustand/shallow";
import { BrowserRouter, Route, Routes, Link } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { Button, Card, useMantineTheme } from "@mantine/core";
import styled from "styled-components";

import { RemoteCodeDetail } from "@pages/Misc";

export default function CodeContainer() {
  return (
    <div>
      <Toaster />
      <BrowserRouter>
        <Routes>
          <Route path="code" element={<>Landing</>} />
          <Route path="code/:id" element={<RemoteCodeDetail />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
